import React from 'react'
import { COLOR_NAME } from '../../constants'
import { clsx } from '../../utils/helper'

import DynamicColor from '../common/dynamic-color'

const RadioButton = ({
    onChange,
    name,
    value,
    checked,
    className = '',
    unCheckClass = '',
    checkedClass = '',
    label,
    icon,
    size
}) => {
    const handleChange = () => {
        !checked &&
            typeof onChange === 'function' &&
            onChange({
                target: {
                    name,
                    value,
                },
            })
    }

    const classes = clsx([
        'app-radio',
        checked ? checkedClass : unCheckClass,
        icon && 'width-icon',
        className,
        size
    ])

    return (
        <DynamicColor
            style={{
                color: COLOR_NAME.BODY_TEXT,
                borderColor: COLOR_NAME.BODY_TEXT,
            }}
            className={classes}
            onClick={handleChange}
        >
            <div className="app-radio__box">
                {icon && (
                    <DynamicColor
                        tag={icon}
                        style={{ width: '22px', height: '22px' }}
                    />
                )}

                {checked && !icon && (
                    <DynamicColor
                        style={{ backgroundColor: COLOR_NAME.BUTTON_BG }}
                        className="app-radio__box--checked"
                    />
                )}
            </div>
            {label}
        </DynamicColor>
    )
}

export default RadioButton
